import { render, staticRenderFns } from "./DialogTageNote.vue?vue&type=template&id=18ea8755&"
import script from "./DialogTageNote.vue?vue&type=script&lang=js&"
export * from "./DialogTageNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports